import { Box, SxProps } from '@mui/material'
interface PropertySpyItemDetailHeader {
    name: string
}

export const PropertySpyItemDetailHeader = (props: PropertySpyItemDetailHeader): JSX.Element => {
    const {
        name = ``
    } = props

    const nameStyle: SxProps = {
        fontWeight: '600',
        fontSize: '20px'
    }

    const photoListContainerStyle: SxProps = {
        width: {
            xs: '100%',
            md: '50%',
        },
        height: {
            xs: '100%',
            md: '50%',
        }
    }

    return (
        <Box>
            <Box
                sx={nameStyle}
            >
                {name}
            </Box>
        </Box>
    )
}